'use client';

import React from 'react';

import { arrowImage } from 'constants/images';

import { MenuItem, Select, SelectProps } from '@mui/material';

interface BasicSelectOption {
  label: string | React.ReactNode;
  value: string;
}

export type BasicSelectProps = SelectProps & {
  options: BasicSelectOption[];
};

export const BasicSelect: React.FC<BasicSelectProps> = ({ options, ...props }) => {
  return (
    <Select
      displayEmpty
      renderValue={(selected) => {
        if (selected && selected !== '') {
          const selectedOption = options.find((option) => option.value === selected);
          return selectedOption ? selectedOption.label : '';
        }

        return <span style={{ color: '#9e9e9e' }}>{props.placeholder}</span>;
      }}
      sx={{
        '& .MuiSelect-select': {
          padding: '8px 12px',
          textAlign: 'start',
          borderRadius: '6px'
        },

        '&.Mui-disabled': {
          backgroundColor: '#f0f0f0',
          borderRadius: '6px'
        }
      }}
      IconComponent={DropdownIcon}
      {...props}
    >
      {options.map(({ label, value }, i) => {
        return (
          <MenuItem key={i} value={value}>
            {label}
          </MenuItem>
        );
      })}
    </Select>
  );
};

const DropdownIcon: React.FC<React.HTMLAttributes<HTMLImageElement>> = (iconProps) => (
  <img
    {...iconProps}
    src={arrowImage.arrowTriangle}
    alt="arrow"
    style={{
      marginRight: 3,
      top: '50%',
      transform: 'translateY(-50%)',
      pointerEvents: 'none',
      ...iconProps.style
    }}
  />
);
